import { render, staticRenderFns } from "./SpecialLayout.vue?vue&type=template&id=efd87e84&"
import script from "./SpecialLayout.vue?vue&type=script&lang=js&"
export * from "./SpecialLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports